import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";

const ReusableModal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = "md",
  isCentered = true,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={size}
      isCentered={isCentered}
    >
      {/* ensure modal overlays sidebar by using very high z-index */}
      <ModalOverlay zIndex={99999} />
      <ModalContent
        zIndex={100000}
        width={["90%", "auto"]}
        minWidth={["auto", "400px", "600px"]}
        margin={"0 auto"}
        borderRadius="12px"
      >
        {title ? <ModalHeader>{title}</ModalHeader> : null}
        <ModalCloseButton />
        <ModalBody>{children}</ModalBody>
        {footer ? <ModalFooter>{footer}</ModalFooter> : null}
      </ModalContent>
    </Modal>
  );
};

export default ReusableModal;
